/* Herstel in het Licht — Shopify Theme JS */
(function(){
  'use strict';

  // ===== Theme toggle (Brand A light / Brand E dark) =====
  var html = document.documentElement;
  var saved = localStorage.getItem('brand');
  if (saved === 'A' || saved === 'E') { html.setAttribute('data-brand', saved); }

  document.addEventListener('click', function(e){
    var toggle = e.target.closest('[data-theme-toggle]');
    if (!toggle) return;
    var current = html.getAttribute('data-brand');
    var next = current === 'A' ? 'E' : 'A';
    html.setAttribute('data-brand', next);
    localStorage.setItem('brand', next);
  });

  // ===== Mobile menu =====
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-menu-toggle]');
    if (btn) {
      var nav = document.getElementById('navLinks');
      if (nav) nav.classList.toggle('open');
      return;
    }
    // Close menu when link clicked
    var link = e.target.closest('#navLinks a');
    if (link) {
      var nav = document.getElementById('navLinks');
      if (nav) nav.classList.remove('open');
    }
  });

  // ===== Scroll reveal =====
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.phase, .testimonial, .tier').forEach(function(el){
      io.observe(el);
    });
  }
})();
